import http from "../http-common";
/* eslint-disable */
class WorkshopKurikulumService {
  workshopKurikulumList(page, itemPerPage, keyword, workshopId) {
    return http.get(
      "/pib-workshop-kurikulum/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&workshop_id=" +
        workshopId,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    return http.post("/pib-workshop-kurikulum", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  update(data) {
    return http.put(`/pib-workshop-kurikulum/${data.id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  delete(id) {
    return http.delete(`/pib-workshop-kurikulum/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
}

export default new WorkshopKurikulumService();
